const excludedToastUrl = ["txnlog", "ce"];

export const toastSuppressedForUrl = (url) => {
  const parts = url.split("/");
  const lastValue = parts[parts.length - 1];
  return excludedToastUrl.includes(lastValue);
};
